"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CaregiverType;
(function (CaregiverType) {
    CaregiverType[CaregiverType["Unknown"] = 0] = "Unknown";
    CaregiverType[CaregiverType["Husband"] = 1] = "Husband";
    CaregiverType[CaregiverType["Wife"] = 2] = "Wife";
    CaregiverType[CaregiverType["Partner"] = 3] = "Partner";
    CaregiverType[CaregiverType["Son"] = 4] = "Son";
    CaregiverType[CaregiverType["Daughter"] = 5] = "Daughter";
    CaregiverType[CaregiverType["Grandson"] = 6] = "Grandson";
    CaregiverType[CaregiverType["GrandDaughter"] = 7] = "GrandDaughter";
    CaregiverType[CaregiverType["GreatGrandson"] = 8] = "GreatGrandson";
    CaregiverType[CaregiverType["GreatGranddaughter"] = 9] = "GreatGranddaughter";
    CaregiverType[CaregiverType["Mother"] = 10] = "Mother";
    CaregiverType[CaregiverType["Father"] = 11] = "Father";
    CaregiverType[CaregiverType["Uncle"] = 12] = "Uncle";
    CaregiverType[CaregiverType["Aunt"] = 13] = "Aunt";
    CaregiverType[CaregiverType["Niece"] = 14] = "Niece";
    CaregiverType[CaregiverType["Nephew"] = 15] = "Nephew";
    CaregiverType[CaregiverType["FemaleNeighbor"] = 16] = "FemaleNeighbor";
    CaregiverType[CaregiverType["MaleNeighbor"] = 17] = "MaleNeighbor";
    CaregiverType[CaregiverType["LegalCareOffice"] = 18] = "LegalCareOffice";
    CaregiverType[CaregiverType["Friend"] = 19] = "Friend";
    CaregiverType[CaregiverType["Sister"] = 20] = "Sister";
    CaregiverType[CaregiverType["Brother"] = 21] = "Brother";
    CaregiverType[CaregiverType["MaleCousin"] = 22] = "MaleCousin";
    CaregiverType[CaregiverType["FemaleCousin"] = 23] = "FemaleCousin";
    CaregiverType[CaregiverType["GreatUncle"] = 24] = "GreatUncle";
    CaregiverType[CaregiverType["GreatAunt"] = 25] = "GreatAunt";
    CaregiverType[CaregiverType["GreatNiece"] = 26] = "GreatNiece";
    CaregiverType[CaregiverType["GreatNephew"] = 27] = "GreatNephew";
    CaregiverType[CaregiverType["BrotherInLaw"] = 28] = "BrotherInLaw";
    CaregiverType[CaregiverType["SisterInLaw"] = 29] = "SisterInLaw";
    CaregiverType[CaregiverType["BrotherInLawBrother"] = 30] = "BrotherInLawBrother";
    CaregiverType[CaregiverType["BrotherInLawSister"] = 31] = "BrotherInLawSister";
    CaregiverType[CaregiverType["MotherInLaw"] = 32] = "MotherInLaw";
    CaregiverType[CaregiverType["FatherInLaw"] = 33] = "FatherInLaw";
    CaregiverType[CaregiverType["UncleInLaw"] = 34] = "UncleInLaw";
    CaregiverType[CaregiverType["AuntInLaw"] = 35] = "AuntInLaw";
    CaregiverType[CaregiverType["ChildInLaw"] = 36] = "ChildInLaw";
    CaregiverType[CaregiverType["SonInLaw"] = 37] = "SonInLaw";
    CaregiverType[CaregiverType["DaughterInLaw"] = 38] = "DaughterInLaw";
    CaregiverType[CaregiverType["GrandsonInLaw"] = 39] = "GrandsonInLaw";
    CaregiverType[CaregiverType["GranddaughterInLaw"] = 40] = "GranddaughterInLaw";
    CaregiverType[CaregiverType["StepMother"] = 41] = "StepMother";
    CaregiverType[CaregiverType["StepFather"] = 42] = "StepFather";
    CaregiverType[CaregiverType["StepSister"] = 43] = "StepSister";
    CaregiverType[CaregiverType["StepBrother"] = 44] = "StepBrother";
    CaregiverType[CaregiverType["StepDaughter"] = 45] = "StepDaughter";
    CaregiverType[CaregiverType["StepSon"] = 46] = "StepSon";
    CaregiverType[CaregiverType["StepGrandchild"] = 47] = "StepGrandchild";
    CaregiverType[CaregiverType["StepGreatGrandchild"] = 48] = "StepGreatGrandchild";
    CaregiverType[CaregiverType["FosterSon"] = 49] = "FosterSon";
    CaregiverType[CaregiverType["FosterDaughter"] = 50] = "FosterDaughter";
    CaregiverType[CaregiverType["FosterMother"] = 51] = "FosterMother";
    CaregiverType[CaregiverType["FosterFather"] = 52] = "FosterFather";
    CaregiverType[CaregiverType["HalfSister"] = 53] = "HalfSister";
    CaregiverType[CaregiverType["HalfBrother"] = 54] = "HalfBrother";
    CaregiverType[CaregiverType["HalfUncle"] = 55] = "HalfUncle";
    CaregiverType[CaregiverType["HalfAunt"] = 56] = "HalfAunt";
    CaregiverType[CaregiverType["HalfMaleCousin"] = 57] = "HalfMaleCousin";
    CaregiverType[CaregiverType["HalfFemaleCousin"] = 58] = "HalfFemaleCousin";
    CaregiverType[CaregiverType["Grandfather"] = 59] = "Grandfather";
    CaregiverType[CaregiverType["Grandmother"] = 60] = "Grandmother";
})(CaregiverType = exports.CaregiverType || (exports.CaregiverType = {}));
exports.default = CaregiverType;
